/**
 * Рекламные блоки AdsGram.
 *
 * Идентификаторы не секретны — они уходят в браузер клиента при показе, — и
 * лежат в коде, а не в окружении: без них реклама просто не показывается, и
 * ловить это на боевом по забытой переменной незачем.
 *
 * Площадка: SIRR Tarot, PlatformID 38445, кабинет `partner.adsgram.ai`.
 * Обратный вызов о досмотре ролика приходит на `/adsgram/reward` и защищён
 * секретом `ADSGRAM_SECRET` (см. `server/src/index.ts`).
 */

/**
 * Ролик за награду. Досмотр подтверждает СЕРВЕР AdsGram обратным вызовом, а не
 * клиент: только поэтому наградой можно открывать расклад досрочно.
 */
export const AD_BLOCK_REWARD = '41129'

/**
 * Полноэкранный показ для тех, кто не платит.
 *
 * Обычного баннера у AdsGram нет вовсе — есть Reward, Interstitial и «задание»
 * в списке заданий, которого у нас нет. Полноэкранный назойливее полоски внизу,
 * поэтому место показа выбрано осторожно: не до расклада и не сразу после
 * текста, а при возврате на главный экран, и не чаще раза за сеанс.
 */
export const AD_BLOCK_INTERSTITIAL = 'int-41217'

/** Не чаще одного полноэкранного показа за сеанс. */
export const INTERSTITIAL_PER_SESSION = 1
